import { Injectable } from '@angular/core'
import { Router } from '@angular/router'
import { Actions, createEffect, ofType } from '@ngrx/effects'
import { of } from 'rxjs'
import { catchError, map, switchMap } from 'rxjs/operators'
import {
  DeleteStaticContentTemplateFailure,
  DeleteStaticContentTemplateRequest,
  DeleteStaticContentTemplateSuccess,
  FetchStaticContentTemplateFailure,
  FetchStaticContentTemplateRequest,
  FetchStaticContentTemplateSuccess,
  FetchStaticContentTemplatesFailure,
  FetchStaticContentTemplatesRequest,
  FetchStaticContentTemplatesSuccess,
  UpdateStaticContentTemplateFailure,
  UpdateStaticContentTemplateRequest,
  UpdateStaticContentTemplateSuccess,
} from './static-content-templates.actions'
import { StaticContentTemplatesService } from './static-content-templates.service'
import * as Wards from './static-content-templates.types'

@Injectable()
export class StaticContentTemplatesEffects {
  constructor(
    private actions: Actions,
    private staticContentTemplateService: StaticContentTemplatesService,
    private router: Router,
  ) {}

  FetchStaticContentTemplates$ = createEffect(() =>
    this.actions.pipe(
      ofType(Wards.FETCH_STATIC_CONTENT_TEMPLATES_REQUEST),
      switchMap((action: FetchStaticContentTemplatesRequest) => {
        return this.staticContentTemplateService
          .fetchStaticContentTemplates(action.payload)
          .pipe(
            map((result) => {
              return new FetchStaticContentTemplatesSuccess(result.data)
            }),
            catchError((err, caught) => {
              return of(new FetchStaticContentTemplatesFailure({ error: err }))
            }),
          )
      }),
    ),
  )

  FetchStaticContentTemplate$ = createEffect(() =>
    this.actions.pipe(
      ofType(Wards.FETCH_STATIC_CONTENT_TEMPLATE_REQUEST),
      switchMap((action: FetchStaticContentTemplateRequest) => {
        return this.staticContentTemplateService
          .fetchStaticContentTemplate(action.id, action.lang)
          .pipe(
            map((result) => {
              return new FetchStaticContentTemplateSuccess(result.data)
            }),
            catchError((err, caught) => {
              return of(new FetchStaticContentTemplateFailure({ error: err }))
            }),
          )
      }),
    ),
  )

  DeleteStaticContentTemplate$ = createEffect(() =>
    this.actions.pipe(
      ofType(Wards.DELETE_STATIC_CONTENT_TEMPLATE_REQUEST),
      switchMap((action: DeleteStaticContentTemplateRequest) => {
        return this.staticContentTemplateService
          .deleteStaticContentTemplate(action.id)
          .pipe(
            switchMap(() => {
              return [new DeleteStaticContentTemplateSuccess()]
            }),
            catchError((err, caught) => {
              return of(new DeleteStaticContentTemplateFailure({ error: err }))
            }),
          )
      }),
    ),
  )

  UpdateStaticContentTemplate$ = createEffect(() =>
    this.actions.pipe(
      ofType(Wards.UPDATE_STATIC_CONTENT_TEMPLATE_REQUEST),
      switchMap((action: UpdateStaticContentTemplateRequest) => {
        return this.staticContentTemplateService
          .updateStaticContentTemplate(action.id, action.payload)
          .pipe(
            switchMap((response) => {
              return [new UpdateStaticContentTemplateSuccess()]
            }),
            catchError(() => {
              return of(new UpdateStaticContentTemplateFailure({}))
            }),
          )
      }),
    ),
  )
}
